import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table, Icon } from 'rsuite';
import { InventoryAvailabilityType } from '../../../../interfaces/inventory';

const { Cell } = Table;

const CheckCell = ({ dataKey, selectedItem, rowData, ...props }) => (
  <Cell {...props}>
    {get('location.id', rowData) === get('location.id', selectedItem) &&
    get('zone.id', rowData) === get('zone.id', selectedItem) ? (
      <Icon icon="check" />
    ) : (
      <Icon icon="check" inverse />
    )}
  </Cell>
);

CheckCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: InventoryAvailabilityType,
  selectedItem: InventoryAvailabilityType
};

CheckCell.defaultProps = {
  rowData: null,
  selectedItem: null
};

export default CheckCell;
